import type {
    GenerateType,
    PointsComputeParams,
    ProjectTransactionsTab,
} from '@/services/points/interface';
import type {ProjectId} from '@/types';

export const pointsKeys = {
    all: ['points'] as const,
    compute: <T extends GenerateType>(request: PointsComputeParams<T> | null) =>
        [...pointsKeys.all, 'compute', request] as const,
    personalSummary: () => [...pointsKeys.all, 'personalSummary'] as const,
    projectSummary: () => [...pointsKeys.all, 'projectSummary'] as const,
    projectTransactionsPrefix: (projectId: ProjectId) =>
        [...pointsKeys.all, 'projectTransactions', projectId] as const,
    projectTransactions: (projectId: ProjectId, pageSize?: number, tab?: ProjectTransactionsTab) =>
        [...pointsKeys.projectTransactionsPrefix(projectId), pageSize, tab] as const,
};
